import React, { useState } from "react";
import MainHeader from "./MainHeader";
import NavLinks from "./NavLinks";

import styles from "./MainNavigation.module.css";
import MenuIcon from "@mui/icons-material/Menu";
import SideDrawer from "./SideDrawer";
import Backdrop from "./Backdrop";

const MainNavigation = () => {
  const [drawerIsOpen, setDrawerIsOpen] = useState(false);

  const openDrawerHandler = () => {
    setDrawerIsOpen(true);
  };

  const closeDrawerHandler = () => {
    setDrawerIsOpen(false);
  };
  return (
    <React.Fragment>
      {drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}
      <SideDrawer show={drawerIsOpen} onClick={closeDrawerHandler}>
        <div className={styles.navDrawer}>
          <NavLinks />
          <button className={styles.contactDrawer}>
            <a href="mailto:greco.guido@hotmail.com?subject=Inquiries">
              Contact Me
            </a>
          </button>
        </div>
      </SideDrawer>
      <MainHeader>
        <h1 className={styles.navTitle}>
          <a to="/">GUIDO GRECO</a>
        </h1>
        <nav className={styles.navLinks}>
          <NavLinks />
        </nav>
        <button className={styles.contactBtn}>
          <a href="mailto:greco.guido@hotmail.com?subject=Inquiries">
            Contact Me
          </a>
        </button>
        <button className={styles.hambBtn} onClick={openDrawerHandler}>
          <MenuIcon />
        </button>
      </MainHeader>
    </React.Fragment>
  );
};

export default MainNavigation;
